import React, { useContext } from 'react';
import { useModal } from 'src/hooks/useModal';
import { I18nContext } from 'src/stores/I18n';
import { Presenter } from './Presenter';

export const AboutQuestionnaireAnswersModal: React.FC = () => {
  const { isVisible, setIsVisible } = useModal('aboutQuestionnaireAnswersModal');
  const localeResources = useContext(I18nContext);

  if (!isVisible) return null;

  return (
    <Presenter
      title={localeResources.questionnaire.aboutTheSurvey}
      pickUpCompleted={localeResources.questionnaire.pickUpCompleted}
      answerFromOrder={localeResources.questionnaire.answerFromOrder}
      answerAfterPaid={localeResources.questionnaire.answerAfterPaid}
      closeModal={() => setIsVisible(false)}
    />
  );
};
